import * as yup from 'yup';

export const CreateSetaScorecardValidationSchema = yup.object().shape({
    organisationsId: yup.string().required('Please select an Organisation').nullable(),
    reportingPeriod: yup.string().required('Please select a reporting period').nullable(),
    scorecardName: yup.string().required('Scorecard name cannot be empty').nullable().max(128, 'Scorecard name must be less than 128 characters'),
});


